module.exports = __webpack_public_path__ + "media/images/favicon-b694d9e047da7f22760e3fdec08deb83.ico";